import { FC } from 'react';
import { useIntl } from 'react-intl';

import { Text } from '~/eds/src/components/Text/Text';

export type IntegrationState = 'apiEmpty' | 'notFound' | null;

type IntegrationStateMessageProps = {
  state: IntegrationState;
};

export const IntegrationStateMessage: FC<IntegrationStateMessageProps> = ({
  state,
}) => {
  const intl = useIntl();

  if (!state) return null;

  switch (state) {
    case 'apiEmpty':
      return (
        <Text>
          {intl.formatMessage({
            id: 'IntegrationUserList.apiEmpty',
            defaultMessage: 'No users found',
            description:
              'When the API returns no users at all for the particular E-Signature Integration',
          })}
        </Text>
      );
    case 'notFound':
      return (
        <Text>
          {intl.formatMessage({
            id: 'IntegrationUserList.notFound',
            defaultMessage: 'No matching user found',
            description:
              'When the API returned users but none match the search keyword',
          })}
        </Text>
      );
    default:
      return null;
  }
};
